module.exports = __webpack_public_path__ + "static/media/recs-hero-line-desktop.dc0aae90.svg";